export const PAYPLAN = Object.freeze({
  FREE: 'sn_free',
  INDIE_MONTHLY: 'snindie_monthly',
  INDIE_YEARLY: 'snindie_yearly',
  PRO_MONTHLY: 'snpro_monthly',
  PRO_YEARLY: 'snpro_yearly',
  ADVANCED_MONTHLY: 'snadv_monthly',
  ADVANCED_YEARLY: 'snadv_yearly',
});

export const PAYPLAN_TIMELINE = Object.freeze({
  sn_free: 'free',
  snindie_monthly: 'monthly',
  snindie_yearly: 'yearly',
  snpro_monthly: 'monthly',
  snpro_yearly: 'yearly',
  snadv_monthly: 'monthly',
  snadv_yearly: 'yearly',
});

export const PAYPLAN_COST = Object.freeze({
  sn_free: 0,
  snindie_monthly: 1,
  snindie_yearly: 12,
  snpro_monthly: 5,
  snpro_yearly: 3,
  snadv_monthly: 7,
  snadv_yearly: 5,
});

export const PAYPLAN_TITLES = Object.freeze({
  [PAYPLAN.FREE]: 'Sketchnote Free',
  [PAYPLAN.INDIE_MONTHLY]: 'Sketchnote Indie',
  [PAYPLAN.INDIE_YEARLY]: 'Sketchnote Indie',
  [PAYPLAN.PRO_MONTHLY]: 'Sketchnote Pro',
  [PAYPLAN.PRO_YEARLY]: 'Sketchnote Pro',
  [PAYPLAN.ADVANCED_MONTHLY]: 'Sketchnote Advanced',
  [PAYPLAN.ADVANCED_YEARLY]: 'Sketchnote Advanced',
});

export const isFreeUser = (plantype: string) => plantype === PAYPLAN.FREE;
export const isIndieUser = (plantype: string) =>
  [PAYPLAN.INDIE_MONTHLY, PAYPLAN.INDIE_YEARLY].includes(plantype);

export const isProUser = (plantype: string) =>
  [PAYPLAN.PRO_MONTHLY, PAYPLAN.PRO_YEARLY].includes(plantype);

export const isAdvUser = (plantype: string) =>
  [PAYPLAN.ADVANCED_MONTHLY, PAYPLAN.ADVANCED_YEARLY].includes(plantype);

export const PLANRULES = Object.freeze({
  workspace: {
    [PAYPLAN.FREE]: 1,
    [PAYPLAN.INDIE_MONTHLY]: 3,
    [PAYPLAN.INDIE_YEARLY]: 3,
    [PAYPLAN.PRO_MONTHLY]: Infinity,
    [PAYPLAN.PRO_YEARLY]: Infinity,
    [PAYPLAN.ADVANCED_MONTHLY]: Infinity,
    [PAYPLAN.ADVANCED_YEARLY]: Infinity,
  },
  formcreation: {
    [PAYPLAN.FREE]: false,
    [PAYPLAN.INDIE_MONTHLY]: true,
    [PAYPLAN.INDIE_YEARLY]: true,
    [PAYPLAN.PRO_MONTHLY]: false,
    [PAYPLAN.PRO_YEARLY]: false,
    [PAYPLAN.ADVANCED_MONTHLY]: true,
    [PAYPLAN.ADVANCED_YEARLY]: true,
  },
  ganttcreation: {
    [PAYPLAN.FREE]: false,
    [PAYPLAN.INDIE_MONTHLY]: false,
    [PAYPLAN.INDIE_YEARLY]: false,
    [PAYPLAN.PRO_MONTHLY]: true,
    [PAYPLAN.PRO_YEARLY]: true,
    [PAYPLAN.ADVANCED_MONTHLY]: true,
    [PAYPLAN.ADVANCED_YEARLY]: true,
  },
  timesheetcreation: {
    [PAYPLAN.FREE]: false,
    [PAYPLAN.INDIE_MONTHLY]: false,
    [PAYPLAN.INDIE_YEARLY]: false,
    [PAYPLAN.PRO_MONTHLY]: false,
    [PAYPLAN.PRO_YEARLY]: false,
    [PAYPLAN.ADVANCED_MONTHLY]: true,
    [PAYPLAN.ADVANCED_YEARLY]: true,
  },
  whiteboardcreation: {
    [PAYPLAN.FREE]: false,
    [PAYPLAN.INDIE_MONTHLY]: false,
    [PAYPLAN.INDIE_YEARLY]: false,
    [PAYPLAN.PRO_MONTHLY]: true,
    [PAYPLAN.PRO_YEARLY]: true,
    [PAYPLAN.ADVANCED_MONTHLY]: true,
    [PAYPLAN.ADVANCED_YEARLY]: true,
  },
  listcreation: {
    [PAYPLAN.FREE]: true,
    [PAYPLAN.PRO_MONTHLY]: true,
    [PAYPLAN.PRO_YEARLY]: true,
    [PAYPLAN.INDIE_MONTHLY]: true,
    [PAYPLAN.INDIE_YEARLY]: true,
    [PAYPLAN.ADVANCED_MONTHLY]: true,
    [PAYPLAN.ADVANCED_YEARLY]: true,
  },
  analyticscreation: {
    [PAYPLAN.FREE]: false,
    [PAYPLAN.INDIE_MONTHLY]: false,
    [PAYPLAN.INDIE_YEARLY]: false,
    [PAYPLAN.PRO_MONTHLY]: true,
    [PAYPLAN.PRO_YEARLY]: true,
    [PAYPLAN.ADVANCED_MONTHLY]: true,
    [PAYPLAN.ADVANCED_YEARLY]: true,
  },
  embedcreation: {
    [PAYPLAN.FREE]: false,
    [PAYPLAN.INDIE_MONTHLY]: true,
    [PAYPLAN.INDIE_YEARLY]: true,
    [PAYPLAN.PRO_MONTHLY]: true,
    [PAYPLAN.PRO_YEARLY]: true,
    [PAYPLAN.ADVANCED_MONTHLY]: true,
    [PAYPLAN.ADVANCED_YEARLY]: true,
  },
  calendarcreation: {
    [PAYPLAN.FREE]: false,
    [PAYPLAN.INDIE_MONTHLY]: false,
    [PAYPLAN.INDIE_YEARLY]: false,
    [PAYPLAN.PRO_MONTHLY]: true,
    [PAYPLAN.PRO_YEARLY]: true,
    [PAYPLAN.ADVANCED_MONTHLY]: true,
    [PAYPLAN.ADVANCED_YEARLY]: true,
  },
  export: {
    [PAYPLAN.FREE]: false,
    [PAYPLAN.INDIE_MONTHLY]: false,
    [PAYPLAN.INDIE_YEARLY]: false,
    [PAYPLAN.PRO_MONTHLY]: true,
    [PAYPLAN.PRO_YEARLY]: true,
    [PAYPLAN.ADVANCED_MONTHLY]: true,
    [PAYPLAN.ADVANCED_YEARLY]: true,
  },
  customFields: {
    [PAYPLAN.FREE]: false,
    [PAYPLAN.INDIE_MONTHLY]: true,
    [PAYPLAN.INDIE_YEARLY]: true,
    [PAYPLAN.PRO_MONTHLY]: true,
    [PAYPLAN.PRO_YEARLY]: true,
    [PAYPLAN.ADVANCED_MONTHLY]: true,
    [PAYPLAN.ADVANCED_YEARLY]: true,
  },
  csvimport: {
    [PAYPLAN.FREE]: false,
    [PAYPLAN.INDIE_MONTHLY]: false,
    [PAYPLAN.INDIE_YEARLY]: false,
    [PAYPLAN.PRO_MONTHLY]: false,
    [PAYPLAN.PRO_YEARLY]: false,
    [PAYPLAN.ADVANCED_MONTHLY]: true,
    [PAYPLAN.ADVANCED_YEARLY]: true,
  },
  versionhistory: {
    [PAYPLAN.FREE]: true,
    [PAYPLAN.INDIE_MONTHLY]: true,
    [PAYPLAN.INDIE_YEARLY]: true,
    [PAYPLAN.PRO_MONTHLY]: true,
    [PAYPLAN.PRO_YEARLY]: true,
    [PAYPLAN.ADVANCED_MONTHLY]: true,
    [PAYPLAN.ADVANCED_YEARLY]: true,
  },
  shareaccesslevels: {
    [PAYPLAN.FREE]: false,
    [PAYPLAN.INDIE_MONTHLY]: false,
    [PAYPLAN.INDIE_YEARLY]: false,
    [PAYPLAN.PRO_MONTHLY]: true,
    [PAYPLAN.PRO_YEARLY]: true,
    [PAYPLAN.ADVANCED_MONTHLY]: true,
    [PAYPLAN.ADVANCED_YEARLY]: true,
  },
  guests: {
    [PAYPLAN.FREE]: 5,
    [PAYPLAN.INDIE_MONTHLY]: 5,
    [PAYPLAN.INDIE_YEARLY]: 5,
    [PAYPLAN.PRO_MONTHLY]: 5,
    [PAYPLAN.PRO_YEARLY]: 5,
    [PAYPLAN.ADVANCED_MONTHLY]: Infinity,
    [PAYPLAN.ADVANCED_YEARLY]: Infinity,
  },
  reporting: {
    [PAYPLAN.FREE]: false,
    [PAYPLAN.INDIE_MONTHLY]: false,
    [PAYPLAN.INDIE_YEARLY]: false,
    [PAYPLAN.PRO_MONTHLY]: false,
    [PAYPLAN.PRO_YEARLY]: false,
    [PAYPLAN.ADVANCED_MONTHLY]: true,
    [PAYPLAN.ADVANCED_YEARLY]: true,
  },
  chat: {
    [PAYPLAN.FREE]: false,
    [PAYPLAN.INDIE_MONTHLY]: false,
    [PAYPLAN.INDIE_YEARLY]: false,
    [PAYPLAN.PRO_MONTHLY]: true,
    [PAYPLAN.PRO_YEARLY]: true,
    [PAYPLAN.ADVANCED_MONTHLY]: true,
    [PAYPLAN.ADVANCED_YEARLY]: true,
  },

  pdf_chat: {
    [PAYPLAN.FREE]: false,
    [PAYPLAN.PRO_MONTHLY]: false,
    [PAYPLAN.INDIE_MONTHLY]: false,
    [PAYPLAN.INDIE_YEARLY]: false,
    [PAYPLAN.PRO_YEARLY]: false,
    [PAYPLAN.ADVANCED_MONTHLY]: true,
    [PAYPLAN.ADVANCED_YEARLY]: true,
  },
  agile: {
    [PAYPLAN.FREE]: false,
    [PAYPLAN.INDIE_MONTHLY]: false,
    [PAYPLAN.INDIE_YEARLY]: false,
    [PAYPLAN.PRO_MONTHLY]: true,
    [PAYPLAN.PRO_YEARLY]: true,
    [PAYPLAN.ADVANCED_MONTHLY]: true,
    [PAYPLAN.ADVANCED_YEARLY]: true,
  },
  globalTimeSheets: {
    [PAYPLAN.FREE]: false,
    [PAYPLAN.INDIE_MONTHLY]: false,
    [PAYPLAN.INDIE_YEARLY]: false,
    [PAYPLAN.PRO_MONTHLY]: false,
    [PAYPLAN.PRO_YEARLY]: false,
    [PAYPLAN.ADVANCED_MONTHLY]: true,
    [PAYPLAN.ADVANCED_YEARLY]: true,
  },
  createTaskWithAi: {
    [PAYPLAN.FREE]: false,
    [PAYPLAN.INDIE_MONTHLY]: false,
    [PAYPLAN.INDIE_YEARLY]: false,
    [PAYPLAN.PRO_MONTHLY]: false,
    [PAYPLAN.PRO_YEARLY]: false,
    [PAYPLAN.ADVANCED_MONTHLY]: true,
    [PAYPLAN.ADVANCED_YEARLY]: true,
  },
});
